/* eslint-disable react/no-unknown-property */
import React, { useState, useRef, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { Fieldset } from 'primereact/fieldset';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { Card } from 'primereact/card';
import { Steps } from 'primereact/steps';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Message } from 'primereact/message';
import { Growl } from 'primereact/growl';
import { ProgressSpinner } from 'primereact/progressspinner';
import SignaturePad from 'react-signature-canvas';
import * as moment from 'moment';

import './styles.css';

import CobAd from './cobrarAdesao';
import AceiEl from './aceiteEletronico';
import { Buscas } from '../../services/dependentes';
import { BuscarAssoc, AtualizarStatus } from '../../services/associados';
import { insereAssinatura, BuscaAssinat } from '../../services/assinaturas';
import ValorAdesao from '../assinatura/valorAdesao';
import { BuscaInscricao } from '../../services/inscricao/index';

import FundoAmarelo from '../../assets/fundo_amarelo.png';
import {
    insereMensalidade,
    atualizaMensalidade
} from '../../services/contratos/index';
import PPdf from './pdf';
import { decriptoLocalStorage } from '../../modulos/cripotografia/criptoStorage';

const Finalizacao = props => {
    const growl = useRef(null);
    const { inscricao } = props.match.params;
    const vendedor = decriptoLocalStorage('codigo_vendedor')?.decriptoValue;
    const [loading, setLoading] = useState('loading');
    const [ass, setAss] = useState(null);
    const [show, setShow] = useState(false);
    const [sucesso, setSucesso] = useState(false);
    const [erro, setErro] = useState(false);
    const [showCanvas, setShowCanvas] = useState(false);
    const [dependentes, setDependentes] = useState([]);
    const [Associado, setAssociado] = useState([]);
    const sigCanvas = useRef({});
    const [valorDep, setValorDep] = useState([]);
    const [valorInsc, setValorInsc] = useState([]);
    const [valorAdesao, setValorAdesao] = useState([]);
    const [image, setImage] = useState([]);

    const clear = ind => {
        setLoading('loading');
        sigCanvas.current.clear();

        if (ind === 2) {
            save(1);
        }
    };

    const [isAdesao, setAdesao] = useState(true);
    const header = <img alt="Card" src={FundoAmarelo} />;
    const [activeIndex] = useState(2);
    const items = [
        { label: 'Associado' },
        { label: 'Dependentes' },
        { label: 'Checkout' }
    ];

    const coordenador = decriptoLocalStorage('codSupervisor')?.decriptoValue;
    const supervisor = decriptoLocalStorage('codCoordenador')?.decriptoValue;

    useEffect(() => {
        async function loadAdesao() {
            await BuscaInscricao(inscricao)
                .then(result => {
                    setValorInsc(result.Valor);
                    setAdesao(false);
                })
                .catch(err => { });
        }

        loadAdesao();
    }, [inscricao]);

    useEffect(() => {
        let ja = 0;

        async function loadDependentes() {
            const regexValor = '/(\d)(?=(\d{3})+\,)/g'
            await Buscas(`/dependentes/${inscricao}`)
                .then(response => {
                    if (response.length > 0) {
                        for (let i = 0; i < response.length; i++) {
                            response[
                                i
                            ].valorDependente = `${response[i]['CategoriaParentesco.Valor'].toFixed(2).replace('.', ',').replace(regexValor, "$1.")}`;
                            ja += response[i]['CategoriaParentesco.Valor'];
                        }
                    }

                    setValorDep(ja);
                    setDependentes(response);

                    return response;
                })
                .catch(error => { });
        }

        loadDependentes();
    }, [inscricao]);

    useEffect(() => {
        async function loadAssociado() {
            await BuscarAssoc(`${inscricao}`)
                .then(response => {
                    setAssociado(response[0]);
                })
                .catch(error => { });
        }

        loadAssociado();
    }, [inscricao]);

    useEffect(() => {
        async function gravaMensalidade() {
            await insereMensalidade(inscricao)
                .then(response => { })
                .catch(error => { });
        }

        gravaMensalidade();
    }, [inscricao]);

    useEffect(() => {
        setValorAdesao(localStorage.getItem('ValorInscricao'));
        localStorage.removeItem('ValorInscricao');
    }, []);

    useEffect(() => {
        async function ValorUpdateMensalidade() {
            await atualizaMensalidade(inscricao)
                .then(response => { })
                .catch(error => { });
        }

        ValorUpdateMensalidade();
    }, [inscricao]);

    const save = async ind => {
        setAss(sigCanvas.current.getTrimmedCanvas().toDataURL('image/png'));
        setShow(!show);

        const obj = {
            id_ass_assoc: inscricao,
            ass_b64: ass,
            ass_path: 'n/a'
        };

        if (ind === 2) {
            if (ass.length > 400) {
                setLoading('nada');
                insereAssinatura(inscricao, obj)
                    .then(response => {
                        setLoading('nada');

                        if (response.status === 400) {
                            setLoading('loading');
                            setTimeout(() => {
                                alert(
                                    'ops, estamos tendo problemas para validadr seus dados'
                                );
                            }, 2000);
                        } else if (response.status === 500) {
                            setLoading('loading');
                            setTimeout(() => {
                                alert(
                                    'ops, estamos tendo problemas para validadr seus dados'
                                );
                            }, 2000);
                        }

                        if (response.message === 'sucessufuly') {
                            setSucesso(true);
                            setLoading('loading');
                            setShowCanvas(false);
                            loadAssinatura();
                        }
                    })
                    .catch(erro => {
                        alert(
                            'ops, estamos tendo problemas para validadr seus dados',
                            erro
                        );
                    });
            } else {
                alert('ops, não detectamos traços suficientes');
                setErro(true);
            }
        }
    };

    const assinatura = () => {
        window.scrollTo(0, 2000);
        setShowCanvas(true);
    };

    useEffect(() => {
        loadAssinatura();
    }, [loadAssinatura]);

    async function loadAssinatura() {
        await BuscaAssinat(inscricao)
            .then(response => {
                setImage(response.ass_b64);
            })
            .catch(error => { });
    }

    const history = useHistory();
    const finalizar = dados => {
        AtualizarStatus(dados, Associado.Status)
            .then(response => {
                if (response.status === 200) {
                    showSuccess('Sucesso! contrato finalizado');
                    setTimeout(() => {
                        history.push('/lista-contratos/');
                    }, 2000);
                } else {
                    showError('Ops! Ocorreu um erro desconhecido');
                }
            })
            .catch(() => {
                showError('Ops! Erro de servidor');
            });
    };

    const showSuccess = message => {
        growl.current.show({
            severity: 'success',
            summary: '',
            detail: message
        });
    };

    const showError = message => {
        growl.current.show({
            severity: 'error',
            summary: '',
            detail: message
        });
    };

    return (
        <div>
            <Growl ref={growl} />
            {isAdesao && (
                <ValorAdesao
                    inscricao={props.match.params.inscricao}
                    valor={valorAdesao}
                />
            )}

            <Card className='tratar-scroll-card' header={header} title="Pagamento e assinatura">
                <div className="p-col-12 p-md-12 p-lg-12 p-sm-12">
                    <Steps model={items} activeIndex={activeIndex} />
                </div>
                <br />
                <br />
                <div className="p-grid p-fluid">
                    <div className="p-col-12 p-md-4 p-lg-3 p-sm-6">
                        <CobAd
                            inscricao={inscricao}
                            mensalidade={Associado['ProdutosPreco.valorBase'] + valorDep}
                        />
                    </div>
                    <div className="p-col-12 p-md-4 p-lg-3 p-sm-3">
                        <AceiEl
                            inscricao={inscricao}
                            email={Associado.AssEmail}
                            celular={Associado.Celular}
                            tipoCob={7}
                        />
                        <br />
                        <br />
                    </div>
                    <div className="p-col-12 p-md-4 p-lg-3 p-sm-3">
                        <PPdf
                            inscricao={inscricao}
                            dependentes={dependentes}
                            Associado={Associado}
                            valorDep={valorDep}
                        />
                        <br />
                        <br />
                    </div>
                    <div className="p-col-12 p-md-4 p-lg-3 p-sm-3">
                        <Button
                            type="submit"
                            label="Finalizar"
                            onClick={() => finalizar(inscricao)}
                        />
                    </div>
                </div>

                <div className="p-grid p-fluid">
                    <div className="p-col-12 p-md-12 p-lg-12 p-sm-12">
                        <Fieldset legend="Contratante">
                            <div className="p-grid p-fluid">
                                <div className="p-col-12 p-md-12">
                                    <div className="p-field p-grid">
                                        <label
                                            htmlFor="Nome"
                                            className="p-col-fixed"
                                            style={{ width: '50px' }}
                                        >
                                            Nome
                                        </label>
                                        <div className="p-col">
                                            <InputText
                                                placeholder="Nome"
                                                name="Nome"
                                                id="Nome"
                                                value={Associado.Nome}
                                                disabled
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="p-col-12 p-md-4">
                                    <div className="p-field p-grid">
                                        <label
                                            htmlFor="Telefone"
                                            className="p-col-fixed"
                                            style={{ width: '90px' }}
                                        >
                                            Celular
                                        </label>
                                        <div className="p-col">
                                            <InputText
                                                name="Celular"
                                                id="Telefone"
                                                value={Associado.Celular}
                                                disabled
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="p-col-12 p-md-4">
                                    <div className="p-field p-grid">
                                        <label
                                            htmlFor="Email"
                                            className="p-col-fixed"
                                            style={{ width: '90px' }}
                                        >
                                            Email
                                        </label>
                                        <div className="p-col">
                                            <InputText
                                                name="Email"
                                                id="Email"
                                                value={Associado.AssEmail}
                                            //disabled
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div className="p-col-12 p-md-4">
                                    <div className="p-field p-grid">
                                        <label
                                            htmlFor="Idade"
                                            className="p-col-fixed"
                                            style={{ width: '90px' }}
                                        >
                                            Nascimento
                                        </label>
                                        <div className="p-col">
                                            <InputText
                                                name="Idade"
                                                id="Idade"
                                                value={moment(
                                                    Associado.Nascimento
                                                )
                                                    .add(3, 'hours')
                                                    .format('DD-MM-YYYY')}
                                                disabled
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="p-col-12 p-md-4">
                                    <div className="p-field p-grid">
                                        <label
                                            htmlFor="Telefone"
                                            className="p-col-fixed"
                                            style={{ width: '90px' }}
                                        >
                                            Carência
                                        </label>
                                        <div className="p-col">
                                            <InputText
                                                name="Carencia"
                                                id="Carencia"
                                                value={Associado.Celular}
                                                disabled
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="p-col-12 p-md-4">
                                    <div className="p-field p-grid">
                                        <label
                                            htmlFor="Email"
                                            className="p-col-fixed"
                                            style={{ width: '90px' }}
                                        >
                                            Mensalidade base
                                        </label>
                                        <div className="p-col">
                                            <InputText
                                                name="Mensalidade"
                                                id="Mensalidade"
                                                value={new Intl.NumberFormat(
                                                    'pt-BR',
                                                    {
                                                        style: 'currency',
                                                        currency: 'BRL'
                                                    }
                                                ).format(
                                                    Associado['ProdutosPreco.valorBase']
                                                )}
                                                disabled
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="p-col-12 p-md-4">
                                    <div className="p-field p-grid">
                                        <label
                                            htmlFor="Idade"
                                            className="p-col-fixed"
                                            style={{ width: '90px' }}
                                        >
                                            Mensalidade total
                                        </label>
                                        <div className="p-col">
                                            <InputText
                                                name="Mensalidade"
                                                id="Mensalidade"
                                                value={new Intl.NumberFormat(
                                                    'pt-BR',
                                                    {
                                                        style: 'currency',
                                                        currency: 'BRL'
                                                    }
                                                ).format(
                                                    Associado['ProdutosPreco.valorBase'] +
                                                    valorDep
                                                )}
                                                disabled
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="p-col-12 p-md-4">
                                    <div className="p-field p-grid">
                                        <label
                                            htmlFor="Idade"
                                            className="p-col-fixed"
                                            style={{ width: '90px' }}
                                        >
                                            Cod Supervisor
                                        </label>
                                        <div className="p-col">
                                            <InputText
                                                name="Supervisor"
                                                id="Supervisor"
                                                value={supervisor}
                                                disabled
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div className="p-col-12 p-md-4">
                                    <div className="p-field p-grid">
                                        <label
                                            htmlFor="Telefone"
                                            className="p-col-fixed"
                                            style={{ width: '90px' }}
                                        >
                                            Cod Coordenador
                                        </label>
                                        <div className="p-col">
                                            <InputText
                                                name="Coordenador"
                                                id="Coordenador"
                                                value={coordenador}
                                                disabled
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="p-col-12 p-md-4">
                                    <div className="p-field p-grid">
                                        <label
                                            htmlFor="Email"
                                            className="p-col-fixed"
                                            style={{ width: '90px' }}
                                        >
                                            Cod vendedor
                                        </label>
                                        <div className="p-col">
                                            <InputText
                                                name="Vendedor"
                                                id="Mensalidade"
                                                value={vendedor}
                                                disabled
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Fieldset>
                        <br />
                        <h2>Dependentes</h2>
                        <br />
                        <DataTable value={dependentes}>
                            <Column field="Nome" header="Nome" />
                            <Column field="Nascimento" header="Nascimento" />
                            <Column field="Parentesco" header="Parentesco" />
                            <Column field="valorDependente" header="Valor" />
                        </DataTable>
                        <br />
                        <br />
                    </div>
                </div>
                <div className="p-grid p-fluid">
                    {!showCanvas ? (
                        <>
                            <div className="p-col-12 p-md-12 p-lg-4 p-sm-4">
                                <Button
                                    type="submit"
                                    label="Assinatura"
                                    onClick={() => assinatura()}
                                />
                            </div>
                            <br />
                            <br />
                            <div className="p-col-12 p-md-12 p-lg-12 p-sm-12">
                                <img
                                    src={image}
                                    style={{ width: '300px' }}
                                    alt="img"
                                />
                            </div>
                            <div className={loading}>
                                <ProgressSpinner
                                    style={{
                                        width: '50px',
                                        height: '30px'
                                    }}
                                    strokeWidth="1"
                                    fill="#EEEEEE"
                                    animationDuration=".5s"
                                />
                            </div>
                            <div className="quinhentos p-col-6 p-md-6">
                                {sucesso && (
                                    <Message
                                        severity="success"
                                        text="Assinatura Salva"
                                    />
                                )}
                                {erro && (
                                    <Message
                                        severity="error"
                                        text="Ops, não conseguimos salvar"
                                    />
                                )}
                            </div>
                        </>
                    ) : (
                        <div className="p-col-12 p-md-12 p-lg-12 p-sm-12">
                            <SignaturePad
                                ref={sigCanvas}
                                canvasProps={{
                                    className:
                                        'signatureCanvas p-col-12 p-md-12 p-lg-12 p-sm-12'
                                }}
                            />

                            <div className={loading}>
                                Carregando...
                                <ProgressSpinner
                                    style={{
                                        width: '50px',
                                        height: '50px'
                                    }}
                                    strokeWidth="1"
                                    fill="#EEEEEE"
                                    animationDuration=".5s"
                                />
                            </div>
                        </div>
                    )}
                </div>
                <br />
                {!show && (
                    <div className="p-grid p-fluid">
                        <div className="p-col-12 p-md-4 p-lg-4 p-sm-4">
                            <button
                                type="submit"
                                icon="pi pi-plus"
                                iconPos="left"
                                className="btn-primary"
                                onClick={() => save(1)}
                            >
                                Assinar
                            </button>
                        </div>
                        <div className="p-col-12 p-md-4 p-lg-4 p-sm-4">
                            <Button
                                type="submit"
                                label="Limpar"
                                onClick={() => clear(1)}
                            />
                        </div>
                    </div>
                )}
                {showCanvas && (
                    <div className="p-grid p-fluid">
                        <div className="p-col-12 p-md-4 p-lg-4 p-sm-4">
                            <button
                                type="submit"
                                icon="pi pi-plus"
                                iconPos="left"
                                className="btn-primary"
                                onClick={() => save(2)}
                            >
                                Confirmar
                            </button>
                        </div>
                        <div className={loading}>
                            <ProgressSpinner
                                style={{
                                    width: '50px',
                                    height: '30px'
                                }}
                                strokeWidth="1"
                                fill="#EEEEEE"
                                animationDuration=".5s"
                            />
                        </div>
                        <div className="p-col-12 p-md-4 p-lg-4 p-sm-4">
                            <button
                                type="submit"
                                icon="pi pi-plus"
                                iconPos="left"
                                className="btn-primary"
                                onClick={() => clear(2)}
                            >
                                Voltar
                            </button>
                        </div>
                    </div>
                )}
            </Card>
        </div>
    );
};

export default Finalizacao;
